import { observer } from "mobx-react-lite";
import React, { Fragment, useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { Button, Header, Icon, Segment } from "semantic-ui-react";
import MyDateInput from "../../app/common/form/MyDateInput";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { MySelectInput, valor } from "../../app/common/form/MySelectInput";
import {
  CCTMovimientoConsulta,
  CCTMovimientoConsultaFormValues,
} from "../../app/models/CCTMovimientoConsulta";
import "./notificaciones.css";
import CreateOperacion from "../Modals/CreateOperacion";
import TablaNotificaciones from "./TablaNotificaciones";
import { EstatusNotificacion } from "../../app/common/options/EstatusNotificacion";
import { TiposNotificacion } from "../../app/common/options/TiposNotificacion";
import TablaNoti from "./TablaNotificaciones";
import { BsJustifyLeft } from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { SubMenuOExoneraciones } from "../Operaciones/MenuOperaciones";

export default observer(function Notifica() {
  const { CCTMovimientoReporteStore, modalStore } = useStore();
  const { loadCCTMovimiento, CCTMovimientoRegistry } =
    CCTMovimientoReporteStore;
  const { ExoneracionesStore, CuotasStore } = useStore();
  const { CCTMovimientoByCodigo, reporte } = CCTMovimientoReporteStore;
  const { loadExoneraciones } = ExoneracionesStore;
  const { loading } = CCTMovimientoReporteStore;

  const [CCTMovimientoConsulta, setSGPersona] =
    useState<CCTMovimientoConsultaFormValues>(
      new CCTMovimientoConsultaFormValues()
    );

  const validationSchema = Yup.object({
    fechaInicial: Yup.date().required("Obligatorio"),
  });

  function handleFormSubmit(
    CCTMovimientoConsulta: CCTMovimientoConsultaFormValues
  ) {
    // buscar
  }

  useEffect(() => {
    loadExoneraciones();
  }, []);

  return (
    <>
      <SubMenuOExoneraciones />
      <div>
        <div className="header_notificacion">
          <h1>Aprobación de Exoneraciones</h1>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <div className="buscar_notificacion">
          <Formik
            validationSchema={validationSchema}
            enableReinitialize
            initialValues={CCTMovimientoConsulta}
            onSubmit={(values) => handleFormSubmit(values)}
          >
            {({ handleSubmit, isValid, isSubmitting, dirty }) => (
              <Form
                className="ui form"
                onSubmit={handleSubmit}
                autoComplete="off"
              >
                <div className="form_buscar_notificacion">
                  <div className="formular">
                    <div className="inputs">
                      <Header size="small" content="Tipo de Notificación" />
                      <MySelectInput
                        id=""
                        name="tipoCuenta"
                        placeholder=" "
                        options={TiposNotificacion}
                      />
                    </div>
                    <div className="inputs">
                      <Header size="small" content="Estatus" />
                      <MySelectInput
                        id=""
                        name="tipoMovimiento"
                        placeholder=" "
                        options={EstatusNotificacion}
                      />
                    </div>
                  </div>

                  <div className="boton_buscar_notificacion">
                    <Button
                      type="submit"
                      content="Buscar"
                      style={{
                        backgroundColor: "#15b3e8",
                        color: "white",
                        height: "38px",
                      }}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          <br></br>
        </div>
        <div>
          <TablaNoti />
        </div>

        <br></br>
        <br></br>
      </div>
    </>
  );
});
